module.exports = __webpack_public_path__ + "img/fengtao.56d8e8af.jpg";